import { render, staticRenderFns } from "./DetalhamentoCategoria.vue?vue&type=template&id=0d83e614&scoped=true"
import script from "./DetalhamentoCategoria.vue?vue&type=script&lang=js"
export * from "./DetalhamentoCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d83e614",
  null
  
)

export default component.exports